import { useEffect } from 'react';

import { useStore } from 'core/store';

/**
 * The agency behind an affinity code, from the affinity lookups (agency flag) and the core-resources
 * agency information, which it fetches when missing. `isAgentSold` is false for a non-agency code.
 */
export const useAgency = (affinityCode) => {
  const { affinityLookups } = useStore();
  const affinityData = affinityLookups.data.find(({ affinity }) => affinity === affinityCode);
  const isAgentSold = Boolean(affinityCode && affinityData?.isAgency);
  const agencyInfo = affinityLookups.agencyInformation[affinityData?.data?.informationId || affinityCode];

  useEffect(() => {
    if (affinityCode && !agencyInfo && !affinityLookups.partialLoading) {
      affinityLookups.getAgencyInformation(affinityData?.data?.informationId || affinityCode);
    }
  }, [affinityLookups, affinityData, affinityCode, agencyInfo]);

  return {
    affinityData,
    isAgentSold,
    agencyInfo,
    agencyName: isAgentSold ? agencyInfo?.name || affinityData?.name || null : null
  };
};
